var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.landing)?_c('div',{staticClass:"landing-section"},[(_vm.landing)?_c('WizardForm',{attrs:{"landing":_vm.landing},on:{"landing-changed":_vm.landingChanged}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }